import * as React from "react";
import { BooleanInput, Create, CreateProps, SimpleForm, TextInput } from "react-admin";

const ReviewCreate = (props: CreateProps) => {
  return (
    <Create {...props}>
      <SimpleForm style={{ display: "flex", width: "100%" }}>
        <TextInput fullWidth source="name" />
        <TextInput fullWidth source="text" />
        <BooleanInput fullWidth source="accepted" />
      </SimpleForm>
    </Create>
  );
};

export default ReviewCreate;
